
const CalendarTable = ({ highlightDays = [], paymentDate = null, numberOfWeeks = 3, isNextMonth = false }) => {
  const weekdays = ["Mon", "Tues", "Wed", "Thurs", "Fri", "Sat", "Sun"];
  
  const renderWeeks = () => {
    const weeks = [];
    
    for (let week = 0; week < numberOfWeeks; week++) {
      const days = [];
      
      for (let day = 0; day < 7; day++) {
        const dayNumber = week * 7 + day + 1;
        
        // Don't render days beyond reasonable month length
        if ((!isNextMonth && dayNumber <= 31) || (isNextMonth && dayNumber <= 11)) {
          const isHighlighted = highlightDays.includes(dayNumber);
          const isPaymentDay = dayNumber === paymentDate;
          
          days.push(
            <td 
              key={day}
              className={`p-3 text-center border-b border-gray-200
                ${isHighlighted ? 'bg-[#fff6dd]' : 'bg-white'}
                ${isPaymentDay ? 'bg-[#d0f5e6] font-bold relative' : ''}
              `}
            >
              {dayNumber}
              {isPaymentDay && 
                <span className="absolute text-[0.65rem] bottom-0.5 left-1/2 transform -translate-x-1/2 text-[#048998]">
                  PAYMENT
                </span>
              }
            </td>
          );
        } else {
          days.push(<td key={day}></td>);
        }
      }
      
      weeks.push(<tr key={week}>{days}</tr>);
    }
    
    return weeks;
  };
  
  return (
    <table className="w-full my-4 bg-white rounded-lg shadow">
      <thead>
        <tr>
          {weekdays.map((day, index) => (
            <th key={index} className="bg-[#048998] text-white p-3 text-center font-semibold">
              {day}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {renderWeeks()}
      </tbody>
    </table>
  );
};


export default CalendarTable;